module.exports = __webpack_public_path__ + "img/Hand_31_05_30.d4eec96d.png";